<template>
  <div class="">
    <nav
      class="
        container
        px-6
        py-8
        mx-auto
        md:flex md:justify-between md:items-center
      "
    >
      <div class="flex items-center justify-between">
        <router-link to="/" class="font-bold text-4xl ml-0 md:ml-10"
          >Bilal.
        </router-link>
        <!-- Mobile menu button -->
        <div @click="toggleNav" class="flex md:hidden">
          <button
            type="button"
            class="
              text-gray-100
              hover:text-gray-400
              focus:outline-none focus:text-gray-400
            "
          >
            <svg
              fill="currentColor"
              viewBox="0 0 20 20"
              class="w-6 h-6"
              style="color: white"
            >
              <path
                :class="showMenu ? 'hidden' : 'flex'"
                fill-rule="evenodd"
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z"
                clip-rule="evenodd"
              ></path>
              <!-- X icon -->
              <path
                :class="showMenu ? 'flex' : 'hidden'"
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Mobile Menu open: "block", Menu closed: "hidden" -->
      <nav
        :class="showMenu ? 'flex' : 'hidden'"
        class="
          flex-col
          mt-8
          space-y-4
          md:flex md:space-y-0 md:flex-row md:items-center md:space-x-10 md:mt-0
          text-center
        "
      >
        <router-link
          class="
            px-4
            py-2
            mt-2
            text-sm
            font-semibold
            bg-transparent
            dark-mode:bg-transparent
            dark-mode:hover:bg-gray-600
            dark-mode:focus:bg-gray-600
            dark-mode:focus:text-white
            dark-mode:hover:text-white
            dark-mode:text-gray-200
            md:mt-0 md:ml-4
            hover:text-gray-900
            focus:text-gray-900
            hover:bg-gray-200
            focus:bg-gray-200 focus:outline-none focus:shadow-outline
          "
          to="/"
          >Home</router-link
        >
        <router-link
          class="
            px-4
            py-2
            mt-2
            text-sm
            font-semibold
            bg-transparent
            dark-mode:bg-transparent
            dark-mode:hover:bg-gray-600
            dark-mode:focus:bg-gray-600
            dark-mode:focus:text-white
            dark-mode:hover:text-white
            dark-mode:text-gray-200
            md:mt-0 md:ml-4
            hover:text-gray-900
            focus:text-gray-900
            hover:bg-gray-200
            focus:bg-gray-200 focus:outline-none focus:shadow-outline
          "
          to="/project"
          >My Projects</router-link
        >
        <router-link
          class="
            px-4
            py-2
            mt-2
            text-sm
            font-semibold
            bg-transparent
            dark-mode:bg-transparent
            dark-mode:hover:bg-gray-600
            dark-mode:focus:bg-gray-600
            dark-mode:focus:text-white
            dark-mode:hover:text-white
            dark-mode:text-gray-200
            md:mt-0 md:ml-4
            hover:text-gray-900
            focus:text-gray-900
            hover:bg-gray-200
            focus:bg-gray-200 focus:outline-none focus:shadow-outline
          "
          to="/archievements"
          >Archievements</router-link
        >
        <router-link
          class="
            px-4
            py-2
            mt-2
            text-sm
            font-semibold
            bg-transparent
            dark-mode:bg-transparent
            dark-mode:hover:bg-gray-600
            dark-mode:focus:bg-gray-600
            dark-mode:focus:text-white
            dark-mode:hover:text-white
            dark-mode:text-gray-200
            md:mt-0 md:ml-4
            hover:text-gray-900
            focus:text-gray-900
            hover:bg-gray-200
            focus:bg-gray-200 focus:outline-none focus:shadow-outline
          "
          to="/contact"
          >Contact</router-link
        >
        <!-- <router-link
          class="px-6 py-2 bg-theme font-bold ml-0 md:ml-2"
          to="/contact"
          >Hire Me</router-link
        > -->
      </nav>
    </nav>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  name: "Navbar",
  setup() {
    let showMenu = ref(false);
    const toggleNav = () => (showMenu.value = !showMenu.value);
    return { showMenu, toggleNav };
  },
};
</script>